import HelpOutline from '@mui/icons-material/HelpOutline'
import { Stack, Tooltip, Typography, useTheme } from '@mui/material'
import useIsSuperUser from '@/services/hooks/useIsSuperUser'
import { SUPER_USER_ONLY_COLOR } from '@/theme/usePixydocsTheme'

type LLMReasoningBlockProps = {
  reasoningText?: string
  superUserOnly?: boolean
}

export default function LLMReasoningBlock({
  reasoningText,
  superUserOnly = false,
}: LLMReasoningBlockProps) {
  const theme = useTheme()
  const isSuperUser = useIsSuperUser()

  if (superUserOnly && !isSuperUser) {
    return null
  }

  return (
    <Stack
      spacing={0.5}
      sx={{
        border: 'solid 1px',
        borderColor: superUserOnly
          ? SUPER_USER_ONLY_COLOR
          : theme.palette.divider,
        py: 1,
        px: 1.5,
        borderRadius: 2,
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="caption" color="text.secondary">
          AI Reasoning
        </Typography>

        <Tooltip title="This reasoning is provided by the AI model. It explains how the AI arrived at its conclusion or recommendation. Because this uses an LLM, the reasoning may not always be reliable.">
          <HelpOutline
            sx={{ fontSize: 16, color: theme.palette.text.secondary }}
          />
        </Tooltip>
      </Stack>
      <Typography variant="body2">{reasoningText || 'None'}</Typography>
    </Stack>
  )
}
